import { Injectable } from "@angular/core";
import { SignUp } from "src/app/models/User/SignUp.model";
import { SignUpResponse } from "src/app/models/User/SignupResponse.model";
import { ApiService } from "../api/api.service";

@Injectable({
    providedIn: 'root'
})
export class RegisterService {

    constructor(private api: ApiService){
    }

    public async emailExists(email: string): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/sign-up/valid-email', {Email: email})
            if(r.success) {
                return r.data
            } 
            return false
        } catch(err) {
            throw(err);
        }
    }

    public async register(user: SignUp): Promise<boolean> {
        try {
            const r = await this.api.post<boolean>('/sign-up', user)
            if(r.success) {
                return r.data
            } else {
                throw(r.message)
            }
        } catch(err) {
            throw(err);
        }
    }

    public async documentExists(document: string): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/sign-up/valid-document', {Document: document})
            if(r.success) {
                return r.data
            } 
            return false
        } catch(err) {
            throw(err);
        }
    }
}